module.exports = __webpack_public_path__ + "images/960801e9eb2b2f4e8c1091119fc49ae6-IMG_5175.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_5175.jpg
// module id = ./src/assets/images/slides/living2/IMG_5175.jpg
// module chunks = 0